// non-compliance counts which can come with a kpi value, per techno (sewerin NB_JOURS kpis for now)
export const EXTRA_KPIS: Record<string, string[]> = {
  sewerin: ['almost_contributing', 'contributing', 'contributing_ytd'],
};

export interface KpiOverviewItem {
  id: string;
  date: Date;
  value: number | null;
  extra: Record<string, number>;
}
